import { createSourceL10n, defineLazyL10n } from '$lib/i18n';
import { ns as componentsNs, preload as preloadComponents } from '$lib/components/_i18n';
import enUS from './locales/en-US.json';

const NS = 'root';
const loaders = import.meta.glob<{ default: Record<string, string> }>('./locales/*.json');
const sharedUnits = [{ ns: componentsNs, preload: preloadComponents }];

export const { l10n, ns, preload } = defineLazyL10n(loaders, NS, enUS, sharedUnits);
export const sourceL10n = createSourceL10n(NS, sharedUnits);
